import React, {useState, useEffect} from 'react'
import { request_delete_product_subcategory } from '../requests'
import WarningModal from '../../../../../../modals/WarningModal'
import { onGetErrorMessage } from '../../../../../../shared/utility'


const DeleteProductSubcategoryModal = props => {

    const { id, open, onClose, onUpdateCompleted } = props
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    //console.log(id)

    useEffect(() => {
        setError('')
        setLoading(false)
    }, [open])

    const onSubmit = async() => {
        setLoading(true)
        setDisabled(true)
        try {
            //console.log(id)
            await request_delete_product_subcategory(id)          
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
            setLoading(false)
        }
        setDisabled(false)
    }

    return(
        <WarningModal open={open} onClose={onClose} error={error} loading={loading} onSubmit={onSubmit} disabled={disabled}/>
    )
}

export default DeleteProductSubcategoryModal